import { EmailService } from "@common/client"
import {
  makeAxiosMutation,
  makeInfiniteQuery,
  makeNoArgsQuery,
  makeQuery,
} from "./utils"

export const emailsBaseKey = ["emails"] as const

const EMAILS_PAGE_SIZE = 50

export type EmailPagesParams = Omit<
  Parameters<typeof EmailService.listEmails>[0],
  "skip" | "limit"
>

export const emailKey = (id: string) => [...emailsBaseKey, id] as const

export const forwardingAddressKey = [
  ...emailsBaseKey,
  "forwarding-address",
] as const

export const forwardingAddressQuery = makeNoArgsQuery({
  serviceCall: EmailService.getForwardingAddress,
  queryKey: forwardingAddressKey,
})

export const emailFilterOptionsQuery = makeQuery({
  serviceCall: EmailService.filterOptions,
  queryKey: (params) => [...emailsBaseKey, "filter-options", params],
})

export const emailsInfiniteQuery = makeInfiniteQuery({
  serviceCall: (params: EmailPagesParams, page) =>
    EmailService.listEmails({ ...params, ...page }),
  queryKey: (params) => [...emailsBaseKey, "infinite", params],
  pageSize: EMAILS_PAGE_SIZE,
})

export const emailQuery = makeQuery({
  serviceCall: EmailService.getEmail,
  queryKey: (params) => emailKey(params.email_id),
})

export const useArchiveEmailMutation = makeAxiosMutation({
  serviceCall: EmailService.archiveEmail,
  invalidates: () => [emailsBaseKey],
})

export const useArchiveEmailsMutation = makeAxiosMutation({
  serviceCall: EmailService.archiveMany,
  invalidates: () => [emailsBaseKey],
})

export const useRestoreEmailsMutation = makeAxiosMutation({
  serviceCall: EmailService.restoreMany,
  invalidates: () => [emailsBaseKey],
})

export const useShareEmailsMutation = makeAxiosMutation({
  serviceCall: EmailService.shareMany,
  invalidates: () => [emailsBaseKey],
})

export const useRestoreEmailMutation = makeAxiosMutation({
  serviceCall: EmailService.restoreEmail,
  invalidates: () => [emailsBaseKey],
})

export const useDeleteEmailMutation = makeAxiosMutation({
  serviceCall: EmailService.deleteEmail,
  invalidates: () => [emailsBaseKey],
})
